import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

export async function sendErrorApiMessage(err, message, useSwal) {
  console.log(err)

  if (err?.response?.data?.message) {
    console.log(`${message}: ${err.response.data.message}`)

    if (useSwal) {
      await Swal.fire({
        title: 'Erro',
        text: err.response.data.message,
        icon: 'error',
      })
    } else {
      return toast.error(err.response.data.message)
    }
  } else {
    if (useSwal) {
      await Swal.fire({
        title: 'Erro',
        text: message,
        icon: 'error',
      })
    } else {
      return toast.error(message)
    }
  }
}
